import React, { useEffect } from 'react';
import * as ReactDOM from 'react-dom';

type Props = {
    documentTitleParts?: Array<string>,
    children: React.ReactNode,
}

function getDocumentTitle(documentTitleParts?: Array<string>): string {
    const baseTitle = 'eleMental';
    const titleSeparator = ' • ';

    if (documentTitleParts) {
        const allDocumentTitleParts: Array<string> = [...documentTitleParts, baseTitle];

        return allDocumentTitleParts.join(titleSeparator);
    }

    return baseTitle;
}

const container = document.getElementById('page-title');
export default ({ documentTitleParts, children }: Props) => {
    useEffect(() => {
        document.title = getDocumentTitle(documentTitleParts);
    });

    return ReactDOM.createPortal(
        (
            <div>
                {children}
            </div>
        ),
        container!,
    );
};
